export default {
  title: 'Skład materiału importowanego',
  helpText: 'Wklej tekst składu materiału w polu poniżej – na przykład skopiowany z arkusza danych lub strony internetowej. Narzędzie automatycznie wykryje zakresy zawartych pierwiastków stopowych i wyświetli je bezpośrednio w tabeli podglądu',
  failure: {
    summary: 'Wykryto niekompletne lub niejednoznaczne wartości',
    details: 'Rozpoznano niektóre pierwiastki stopowe, ale brakuje odpowiadających im wartości lub nie można ich jednoznacznie zinterpretować. Prosimy o zapoznanie się z poniższą listą i ręczne uzupełnienie brakujących informacji.',
    emptyValue: 'Nie znaleziono wartości dla pierwiastka stopowego',
    addToComposition: 'Dodaj element',
    removeFromComposition: 'Usuń element',
  },
};
